import DOMPurify from 'dompurify';
import type { Directive, DirectiveBinding } from 'vue';

function render(el: HTMLElement, binding: DirectiveBinding): void {
  if (binding.value === null || binding.value === undefined) {
    el.innerHTML = '';
    return;
  }

  el.innerHTML = DOMPurify.sanitize(String(binding.value));
}

/**
 * Drop-in, safe replacement for `v-html`: renders the bound value as sanitized HTML.
 * Registered globally as `v-safe-html`.
 *
 * Raw `v-html` is banned to avoid stored XSS via ticket comments/notifications.
 */
export const vSafeHtml: Directive<HTMLElement, unknown> = {
  mounted: render,
  updated: render,
};
